import React from 'react';
import { useNavigate } from 'react-router-dom';

function Event() {
    const navigate = useNavigate();

    return (
        <div className="relative pt-20 lg:pt-[40px]">
            {/* Back Button and Logo */}
            <div className="flex justify-between xl:px-[120px] px-3 my-4">
                <button
                    onClick={() => navigate(-1)}
                    className="flex gap-4 items-center cursor-pointer w-[100px]"
                >
                    <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M19 11.4997H7.82999L12.71 6.61967C13.1 6.22967 13.1 5.58967 12.71 5.19967C12.6175 5.10697 12.5076 5.03342 12.3866 4.98324C12.2656 4.93306 12.136 4.90723 12.005 4.90723C11.874 4.90723 11.7443 4.93306 11.6234 4.98324C11.5024 5.03342 11.3925 5.10697 11.3 5.19967L4.70999 11.7897C4.61728 11.8822 4.54373 11.9921 4.49355 12.113C4.44337 12.234 4.41754 12.3637 4.41754 12.4947C4.41754 12.6256 4.44337 12.7553 4.49355 12.8763C4.54373 12.9973 4.61728 13.1072 4.70999 13.1997L11.3 19.7897C11.3926 19.8823 11.5025 19.9557 11.6234 20.0058C11.7444 20.0559 11.8741 20.0817 12.005 20.0817C12.1359 20.0817 12.2656 20.0559 12.3865 20.0058C12.5075 19.9557 12.6174 19.8823 12.71 19.7897C12.8026 19.6971 12.876 19.5872 12.9261 19.4662C12.9762 19.3453 13.002 19.2156 13.002 19.0847C13.002 18.9537 12.9762 18.8241 12.9261 18.7031C12.876 18.5822 12.8026 18.4723 12.71 18.3797L7.82999 13.4997H19C19.55 13.4997 20 13.0497 20 12.4997C20 11.9497 19.55 11.4997 19 11.4997Z"
                            fill="#11485B"
            />
          </svg>
          <p className="text-[#11485B] font-[600]">Back</p>
                </button>
                <img
                    src="../assets/logo3.png"
                    alt="Logo"
                    className="w-[150px] lg:w-[200px]"
                />
            </div>

            <div className="text-black relative bg-cover xl:justify-between justify-center overflow-x-auto flex gap-5 px-3 xl:px-0">
                <div className="flex xl:flex-wrap xl:justify-center w-full gap-10 snap-x snap-mandatory xl:px-20 md:px-5 px-2">
                    <img
                        src="/assets/logo/image.png"
                        alt="Logo"
                        className="mb-4 w-[80%] max-w-full lg:w-[80%]"
                    />
                </div>
            </div>

            {/* Divider Line */}
            <div className="bg-[#139EB5] w-full h-[40px]"></div>
        </div>
    );
}

export default Event;
